export class FiltroSimplesDTO {
  public codigo!: string;
  public nome!: string;
}